import { get, post } from "helpers/api_helper";

export const addCommision = (data) => {
  return post("/admin/addCommision", data);
};
export const getAllCommision = () => {
  return get("/admin/getAllCommision");
};
